import { Card, Modal, Button } from 'react-bootstrap';
import Spinner from '#Components/Spinner'
import { useMemo } from 'react';

const { Header, Body, Footer } = Card;

export default function Page404Modal(props) {

    const { customContent, setModalProps } = props //customContent should be location.pathname

    const spinnerOptions = useMemo(() => {
        return {
            lineWidth: 3,
            petals: 9,
            radius: 50,
            persist: true,
            counterSpin: true,
            onClick: () => setModalProps({ showing: false }) //closes modal without prematurely resetting props like callback
        }
    }, [])

    return (
        <Modal.Body>
            <Card style={{}}>
                <Header className="text-center rocky" >
                    <div className="mt-1">
                        <i className="fa fa-exclamation-triangle d-inline-block me-3"></i>
                        Page not found
                        <i className="fa fa-exclamation-triangle d-inline-block ms-3"></i>
                    </div>
                </Header>
                <Body className="avenir">
                    <div className="d-flex flex-column align-items-center">
                        <p className="mb-1">Sorry, but the page you were looking for:</p>
                        <p className="rocky my-1 spark">{customContent}</p>
                        <p> does not exist. </p>
                        <i className="fa fa-frown d-block mb-3"></i>
                        <div className="d-flex justify-content-center">
                            <div className="align-self-center">
                                <Spinner options={spinnerOptions}></Spinner>
                            </div>
                        </div>
                    </div>
                </Body>
                <Footer className="text-center rocky m-0" >
                    <Button className="w-100" variant="primary" onClick={() => setModalProps({ showing: false })}>
                        <div className="mt-1">
                            <i className="fa fa-home d-inline-block me-3"></i> Go back home. 
                        </div>
                    </Button>
                </Footer>
            </Card>
        </Modal.Body>
    )
}